import UploadInput from './UploadInput';

export default UploadInput;


// WEBPACK FOOTER //
// ./src/components/Form/components/UploadInput/index.tsx